import { IDomainData } from "../datatypes";
import {isObject} from "./mobx-utils";

/**
 * get parts which are separated by comma(,) between the parenthesis
 * return parts
 */
export const ID_SEPARATOR = ":";

export function getEventHandlerArgs(eventHandler:string) {
  eventHandler = eventHandler.trim();
  return eventHandler.substring(eventHandler.indexOf("(")+1,eventHandler.length - 1).split(',');
}

/**
 * 
 * @param {DomainData} domainData
 * @returns a uniqui identifier of the given domain data in format of <edge name>:<domain data id>
 */
export function getDomainDataIdentifier(domainData:any){
  if(domainData && isObject(domainData)){
    if(domainData.Id && domainData._edgeName){
      return domainData._edgeName + ID_SEPARATOR + domainData.Id;
    }else{
      throw Error("getDomainDataIdentifier:illegalArgument expect both Id and _edgeName proerties");
    }
  }else{
    throw Error("getDomainDataIdentifier:illegalArgument "+typeof domainData);
  }
}

/**
 * flat the given domain data tree to map of domain data tree node where key is the computed identifer of each domain data node.
 * 
 * @param domainObject 
 * @param obj 
 */
export function toObjectIdMap(domainObject:any, obj?:{[key:string]:IDomainData}) {
    if(!obj){
        obj = {}
    }
  if(domainObject && domainObject.Id) {
    obj[getDomainDataIdentifier(domainObject)] = domainObject;
  }

  if (isObject(domainObject) || Array.isArray(domainObject)) {
    for(let idx in domainObject) {
      toObjectIdMap(domainObject[idx], obj);
    }
  }
  return obj;
}